import { z } from 'zod'

// a single live last-price update for one instrument. `ts` is the broker tick time
// (ISO string over the wire; coerced to Date when parsed server-side).
export const livePriceTickSchema = z.object({
  instrumentUid: z.string(),
  price: z.number(),
  ts: z.coerce.date(),
})

export type LivePriceTickDto = z.infer<typeof livePriceTickSchema>
